import {
  EntityAvatar,
  EntityAvatarFallback,
  EntityAvatarImage,
  Icon,
} from "@salestrak/ui";
import { urlHost } from "@salestrak/custom-fields";

import { faviconSrc } from "#app/lib/utils/favicon";

/**
 * The 16px site glyph leading a URL value at rest: the site's favicon once it
 * loads, a globe until then and whenever the host has none or cannot be
 * parsed. Decorative — the value text beside it carries the meaning.
 */
export function UrlFavicon({ url }: { url: string }) {
  const host = urlHost(url);
  return (
    <EntityAvatar
      aria-hidden
      size="2xs"
      shape="square"
      // A favicon is artwork, not a photo: no surface fill behind it and no
      // containment hairline over it — both would box the glyph.
      className="bg-transparent after:hidden"
    >
      {host && <EntityAvatarImage alt="" src={faviconSrc(host)} />}
      <EntityAvatarFallback className="bg-transparent text-muted-foreground">
        <Icon name="globe" size="sm" />
      </EntityAvatarFallback>
    </EntityAvatar>
  );
}
